import type { SendAdvisoryCounts, SendReportCounts } from '@/model/Agent.model';

/**
 * What part of a result showed against what it found. Read from exact counts, so a finding a limit
 * left out is always counted here even though it is missing from the list.
 */
export interface SendOmission {
  /** How many of the checks' findings the result shows. */
  shown: number;
  /** How many the checks found. */
  found: number;
  /** How many Benchling In Vivo AI notes there were, before any limit. */
  aiNotes: number;
  aiNotesNotShown: number;
}

export const omissionOf = (counts: SendReportCounts, advisory: SendAdvisoryCounts): SendOmission => ({
  shown: counts.displayed_samples,
  found: counts.finding_groups,
  aiNotes: advisory.observations,
  aiNotesNotShown: advisory.omitted_observations,
});

export const findingsNotShown = (omission: SendOmission): number => Math.max(0, omission.found - omission.shown);
